import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import DatePicker from 'react-multi-date-picker';
import Loader from 'react-js-loader';
import loader from '../icons/loder.gif';
import admindata from '../components/admindata';

import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net';
import { Link } from 'react-router-dom'
import { apiRequest } from '../store/allApi'



function Earings() {
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  const baseUrl = nodeMode === 'development' ? beckendLocalApiUrl : beckendLiveApiUrl;

  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const [EARING, setEARING] = useState([]);
  const [TOTELEARING, setTOTELEARING] = useState(0);

  const Year = new Date().getFullYear();
  const Month = new Date().getMonth() + 1;
  const formattedMonth = Month < 10 ? `0${Month}` : `${Month}`;
  const dynamicStartDate = `${Year}/${formattedMonth}/01`;
  const dynamicEndDate = `${Year}/${formattedMonth}/31`;
  const [startDate, setStartDate] = useState(dynamicStartDate);
  const [endDate, setEndDate] = useState(dynamicEndDate);

  const tableRef = useRef(null); // Reference to the table DOM element

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const handlePageClick = async (data) => {
    const currentPage = data.selected;
    setPageNumber(currentPage);
  };

  const fetchData =async () => {
    const access_token = localStorage.getItem('token');
    setLoading(true);
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/Earning?page=${pageNumber + 1}&_limit=${limit}&FROM_DATE=${startDate}&TO_DATE=${endDate}`,"GET", null,headers)
     if (res.data) {
         setLoading(false);
        setEARING(res.data.admin);
        setNumberOfPages(res.data.totalPages);
        initializeDataTable(); // Initialize DataTables after data is fetched
     }
        } catch (e) {
          setLoading(false);
        }
        finally {
        }

   
    try {
      const res = await apiRequest(`admin/Earning/total?&FROM_DATE=${startDate}&TO_DATE=${endDate}`,"GET", null,headers)
     if (res.data) {
      setTOTELEARING(res.data.total);
     }
        } catch (e) {
          setLoading(false);
        }
        finally {
        }
  };

  const initializeDataTable = () => {
    const table = $(tableRef.current);

    if ($.fn.DataTable.isDataTable(table)) {
      table.DataTable().destroy(); // Destroy existing DataTable instance
    }

    table.DataTable({
      paging: false,
      searching: false,
      ordering: false,
    });
  };

  useEffect(() => {
    fetchData();

    return () => {
      const table = $(tableRef.current);
      if ($.fn.DataTable.isDataTable(table)) {
        table.DataTable().destroy(); // Clean up on unmount
      }
    };
  }, [pageNumber, limit, startDate, endDate]);

  const createDownloadData = () => {
    handleExport();
  };

  const handleExport = () => {
    const table1 = [
      {
        A: 'id',
        B: 'Amount',
      },
    ];

    EARING.forEach((row) => {
      table1.push({
        A: `Earn From Challenge ${row.Earned_Form} on ${row.createdAt}`,
        B: row.Ammount,
      });
    });

    const ws = XLSX.utils.json_to_sheet(table1, { skipHeader: true });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
    XLSX.writeFile(wb, 'AdminEarning.xlsx');
  };

  return loading ? (
    <div className="App">
      <div className="item dashboaed_loader">
        <Loader
          type="bubble-ping"
          bgColor={'#fff'}
          title={<img src={loader} alt="Loading..." />}
          color={'#000'}
          size={100}
        />
      </div>
    </div>
  ) : (
    <div className="row">
      <div className="col-12 grid-margin">
        <div className="card text-white">
          <div className="card-body text-light table_bg">
            <h3 className="d-flex flex-row dashboard_heading">
              Admin Total Earning: ₹ {TOTELEARING}
            </h3>
            <div className="d_flex_both_center">
              <select
                className="form-control col-sm-1 m-1"
                id="pagelimit"
                name="pagelimit"
                onChange={(e) => setLimit(e.target.value)}
              >
                <option value="10">Set limit</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="500">500</option>
              </select>
              <DatePicker
                value={startDate}
                onChange={handleStartDateChange}
                placeholderText="Start Date"
                style={{ height: '40px' }}
              />
              <DatePicker
                value={endDate}
                onChange={handleEndDateChange}
                placeholderText="End Date"
                style={{ height: '40px' }}
              />
              {admindata?.user?.usertype === 'Admin' && (
                <button
                  onClick={createDownloadData}
                  className="btn btn-primary ml-2"
                  style={{ height: '40px' }}
                >
                  Export Data
                </button>
              )}
            </div>
            <div className="table-responsive">
              <table ref={tableRef} className="table text-white">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>_id</th>
                    <th>Amount</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {EARING.map((Earing, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <span>
                          Earn From Challenge {Earing.Earned_Form} on {Earing.createdAt}
                        </span>
                      </td>
                      <td>{Earing.Ammount}</td>
                      <td>
                            <Link
                              type='button'
                              className='btn btn-primary mx-1'
                              to={`/view/${Earing.Game_id}`}
                            >
                              View
                            </Link>
                          </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <ReactPaginate
              previousLabel={'Previous'}
              nextLabel={'Next'}
              breakLabel={'...'}
              pageCount={numberOfPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={'pagination justify-content-center'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextClassName={'page-item'}
              nextLinkClassName={'page-link'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
              activeClassName={'active'}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Earings;
